<script>
  import { inertia } from '@inertiajs/svelte';

  export let data;
</script>

<div class="left">
  {#if data.title}
    <h2 class="h4 left__title">{data.title}</h2>
  {/if}
  {#if data.desc}
    <p class="left__desc">{data.desc}</p>
  {/if}
  {#if data.button}
    <div class="left__more">
      <a
        class="btn btn-icon btn-main btn-main--light"
        href={data.button.url}
        use:inertia
      >
        <i class="isax isax-arrow-right-3" />
        <span>{data.button.title}</span>
      </a>
    </div>
  {/if}
</div>

<style lang="scss">
  .left {
    @include resp-max('m') {
      margin-top: 5rem;
    }

    @include resp-max('s') {
      margin-top: 3rem;
    }

    &__title {
      @include resp-max('s') {
        font-size: 2.4rem;
      }
    }
    &__desc {
      padding-top: 2rem;

      @include resp-max('s') {
        font-size: 1.6rem;
      }
    }
    &__more {
      padding-top: 2rem;
    }
  }
</style>
